import * as React from 'react';
import './Tree-Decorate.css';

export default function TreeDecorate() {
  return (
    <div className="App-tree__decorate">
      Вы нярядили
      <div className="trees-decorate">
        <div className="tree-decorate" />
        <div className="tree-decorate" />
      </div>
    </div>
  );
}
